import { notFound } from '@tanstack/react-router';
import { clientEnv } from '@/env';

export const publicToolsEnabled = clientEnv.publicToolsEnabled;

export function assertPublicToolsEnabled() {
  if (!publicToolsEnabled) {
    throw notFound();
  }
}
